import { useStoreActions } from '@src/model/hooks';
import creatorSdk from '@src/services/creator-sdk';
import type { FC } from 'react';
import { memo, useEffect } from 'react';

export type ModalType = 'sellToken' | 'sendToken' | 'deposit' | 'auth';

export interface SystemBackdoorProps {
    isAppReady: boolean;
}

const SystemBackdoor: FC<SystemBackdoorProps> = props => {
    const { isAppReady } = props;

    const logout = useStoreActions(actions => actions.user.logout);

    useEffect(() => {
        if (!window.deWeb.onAppReady || !isAppReady) return;
        if (typeof window.deWeb.onAppReady !== 'function') return;

        window.deWeb.onAppReady();
    }, [isAppReady]);

    window.deWeb.logout = () => {
        logout();
    };

    window.deWeb.firebaseSignInWithCustomToken = async customToken => {
        await creatorSdk.accountModule.firebaseSignInWithCustomToken(customToken);
    };

    return <div />;
};

export default memo(SystemBackdoor);
